
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorPlayersProfileNavigationVue from "@/components/administrator/players/profile/navigation.vue";
import AdministratorPlayersProfileRootMatchesIndexVue from "@/views/app/administrator/players/profile/root/matches/index.vue";
import AdministratorPlayersProfileRootTrainingsIndexVue from "@/views/app/administrator/players/profile/root/trainings/index.vue";
import AdministratorPlayersProfileRootUserInformationIndexVue from "@/views/app/administrator/players/profile/root/user-information/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorPlayersProfileNavigationVue,
    AdministratorPlayersProfileRootMatchesIndexVue,
    AdministratorPlayersProfileRootTrainingsIndexVue,
    AdministratorPlayersProfileRootUserInformationIndexVue,
  },
})
export default class AdministratorPlayersProfileRootIndexVue extends Vue {
}
